import {Checkbox, Text} from '@smart/react-components';
import React, {useContext} from 'react';
import type {BooleanSchema} from 'yup';
import type {Maybe} from '../../../graphql';
import {FieldContext} from './field-wrapper';
import {parseFieldErrors} from './helpers';
import type {ICommonFieldProps, IWrapperProvider} from './types';
import {useFieldSetup} from './use-field-setup';

type CheckboxInputProps = React.ComponentProps<typeof Checkbox>;

interface IProps extends ICommonFieldProps {
  name?: string;
  initial?: boolean;
  props?: Partial<CheckboxInputProps>;
  schema?: BooleanSchema;
  label?: Maybe<string>;
}
const CheckboxField = function ({
  tag,
  initial = false,
  required,
  props: originalProps,
  schema,
  label,
}: IProps) {
  const {state, errors, showErrors, disabled, getLabel, genericHandler} =
    useContext<IWrapperProvider>(FieldContext as any);

  useFieldSetup(tag, initial, schema);

  const [isInvalid, errorMessage] = parseFieldErrors(tag, errors, showErrors);

  const handleChange = (checked: boolean | 'indeterminate') => {
    genericHandler(tag, checked === true);
  };

  return tag in state ? (
    <Checkbox
      value=""
      id={tag as string}
      name={tag as string}
      onCheckedChange={handleChange}
      invalid={isInvalid}
      checked={state[tag] as boolean}
      disabled={disabled}
      {...originalProps}
    >
      {getLabel(tag, required, label)}
      {isInvalid && errorMessage && (
        <>
          <Text className="error-message">{errorMessage}</Text>
        </>
      )}
    </Checkbox>
  ) : null;
};
export default CheckboxField;
